import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}><rect x="1" y="1" width="22" height="22" rx="8" stroke="#979797" strokeWidth="2" fill="none" fillRule="evenodd" /></svg>);